import React from 'react';
import { ToolsData } from '../../Resources/Data/ToolsData';
import '../../CSS/AboutPage.css';

function ToolsBlock() {
    // Group tools by category
    const groupedTools = ToolsData.reduce((acc, tool) => {
        if (tool.showItem) {
            if (!acc[tool.category]) {
                acc[tool.category] = [];
            }
            acc[tool.category].push(tool);
        }
        return acc;
    }, {} as Record<string, typeof ToolsData>);

    return (
        <div className="Tools-block">
            <div className="Tools-grid">
                {Object.entries(groupedTools).map(([category, tools]) => (
                    <div key={category} className="Tool-category">
                        <h3 className="Category-title">{category}</h3>
                        <div className="Category-tools">
                            {tools.map((tool) => (
                                <div key={tool.id} className="Tool-item">
                                    {tool.logoPath && (
                                        <div className="Tool-logo">
                                            <img src={tool.logoPath} alt={`${tool.name} logo`} />
                                        </div>
                                    )}
                                    <span className="Tool-name">{tool.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ToolsBlock;
